/**
 * Modern Portrait-Image “contain” Toggler (Interaction Optimized)
 */

(function() {
  const SELECTORS = [
    "img.main-slide-img",
    "img.imageslide-item_image",
    "img.swiper-slide-image",
    "img.main-second-img",
    "img.hover-second-img"
  ].join(", ");

  window.applyContainLogic = function(img) {
    if (!img) return false;
    
    // If image hasn't loaded dimensions yet, wait for it naturally
    if (!img.naturalWidth || !img.naturalHeight) {
      if (!img.dataset.containListenerAttached) {
        img.addEventListener("load", () => window.applyContainLogic(img), { once: true });
        img.dataset.containListenerAttached = "true";
      }
      return false;
    }
    
    const isRollover = img.classList.contains('main-second-img') || 
                       img.classList.contains('hover-second-img');

    if (!isRollover) {
      const isPortrait = img.naturalHeight > img.naturalWidth;
      if (isPortrait) {
        img.classList.add("contain");
      } else {
        img.classList.remove("contain");
      }
    } else {
      img.classList.remove("contain");
    }
    
    return true;
  };

  function scanForPortraitImages(container = document) {
    if (!container.querySelectorAll) return;
    container.querySelectorAll(SELECTORS).forEach(img => {
      window.applyContainLogic(img);
    });
  }

  // Initial Scan
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => scanForPortraitImages());
  } else {
    scanForPortraitImages();
  }

  // Mutation Engine for AJAX/Infinite Scroll
  const portraitContainObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.closest('.stamped-badge, .recharge-widget, #stamped-main-widget')) continue; 
          
          if (node.matches(SELECTORS)) window.applyContainLogic(node);
          scanForPortraitImages(node);
        }
      }
      if (mutation.type === "attributes" && (mutation.attributeName === "src" || mutation.attributeName === "style")) {
        if (mutation.target.matches(SELECTORS)) {
          window.applyContainLogic(mutation.target);
        }
      }
    }
  });

  const observationTarget = document.getElementById('product-grid') || document.body;
  portraitContainObserver.observe(observationTarget, { 
    childList: true, 
    subtree: true,
    attributes: true,
    attributeFilter: ["src", "style"]
  });

  // INTERACTION FIX: Global event dispatcher hook to solve timing race conditions
  window.addEventListener('gallery:sync', () => {
    scanForPortraitImages();
    // Staggered backups to account for slow hardware transitions
    setTimeout(() => scanForPortraitImages(), 50);
    setTimeout(() => scanForPortraitImages(), 200);
    setTimeout(() => scanForPortraitImages(), 400);
  });

  window.addEventListener("resize", () => scanForPortraitImages(), { passive: true });
})();